import { DateTime } from "luxon";
import type { Student } from "../../providers/studentsProvider";

interface ExamInKpis {
  date: DateTime;
  rsvp?: "pending" | "accepted" | "declined" | "rejected" | "canceled" | "no-show";
}

export function isExaminationAssignmentExpired(examinationAssignmentExpiresAt: string, now = DateTime.now()): boolean {
  const today = now.setZone("Europe/Berlin").toISODate();
  return !!today && examinationAssignmentExpiresAt < today;
}

export function getExamPlannedDisplayValue(student: Student): string {
  let nextExam: ExamInKpis | undefined;
  const pendingExams: ExamInKpis[] = [];
  const theoryExams = Object.values(student.kpis.theoryExams);
  pendingExams.push(
    ...theoryExams.filter((exam) => !exam.result && (exam.rsvp === "pending" || exam.rsvp === "accepted")),
  );

  for (const bookedTraining of student.bookedTrainings) {
    if (!bookedTraining.isFinished) {
      const practicalExams = Object.values(bookedTraining.kpis?.practicalExams ?? {});
      pendingExams.push(
        ...practicalExams.filter((exam) => !exam.result && (exam.rsvp === "pending" || exam.rsvp === "accepted")),
      );
    }
  }
  pendingExams.sort((firstExam, secondExam) => firstExam.date.toMillis() - secondExam.date.toMillis());
  if (pendingExams.length > 0) {
    nextExam = pendingExams[0];
  }
  if (!nextExam) {
    return "Nein";
  }

  let displayedValue = `Ja, am ${nextExam.date.toLocaleString(undefined, { locale: "de" })}`;
  const today = DateTime.now().startOf("day");
  const days = Math.round(today.diff(nextExam.date.startOf("day"), "days").days);
  if (days < -1) {
    displayedValue += ` (in ${-days} Tagen)`;
  } else if (days === -1) {
    displayedValue = "Ja, morgen";
  } else if (days === 0) {
    displayedValue = "Ja, heute";
  } else if (days === 1) {
    displayedValue = "Ja, gestern";
  } else if (days > 1) {
    displayedValue += ` (vor ${days} Tagen)`;
  }
  if (nextExam.rsvp === "pending") {
    displayedValue += days < 0 ? " • noch nicht bestätigt!" : " • nicht bestätigt";
  }
  return displayedValue;
}
